<template>
  <!-- 预约咨询 -->
  <div>
    <FDBannerImg />
    <div class="appointment_wrap">
      <div class="title">欢迎使用预约咨询服务</div>
      <div class="tips_box">
        <pre>{{ config.info2 }}</pre>
      </div>
      <el-form
        label-position="top"
        :model="form"
        :rules="rules"
        ref="ruleForm"
        style="width: 600px; margin: 0 auto"
      >
        <el-form-item prop="name">
          <template #label>
            <span> 1、<span class="type_text">[填写]</span> 姓名</span>
          </template>
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="rdrno">
          <template #label>
            <span> 2、<span class="type_text">[填写]</span> 学号</span>
          </template>
          <el-input v-model="form.rdrno"></el-input>
        </el-form-item>
        <el-form-item prop="item">
          <template #label>
            <span
              >3、 <span class="type_text">[单选]</span>
              就读管院项目
            </span>
          </template>
          <el-radio-group v-model="form.item" class="group_box">
            <el-radio label="本硕博"></el-radio>
            <el-radio label="MF"></el-radio>
            <el-radio label="DDIM/GMiM"></el-radio>
            <el-radio label="DSBA"></el-radio>
            <el-radio label="MBA"></el-radio>
            <el-radio label="EMBA"></el-radio>
            <el-radio label="MPAcc"></el-radio>
            <el-radio label="其他">
              其他
              <el-input
                v-model="otherItem"
                size="mini"
                style="width: 300px"
              ></el-input>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="consultInfo">
          <template #label>
            <span> 4、<span class="type_text">[多选]</span> 预约咨询内容</span>
          </template>
          <el-checkbox-group v-model="form.consultInfo" class="group_box">
            <el-checkbox
              :label="key"
              v-for="(value, key, index) in consult"
              :key="index"
            >
              {{ key }}
              <el-input
                v-model="form[value]"
                size="mini"
                style="width: 300px"
                type="textarea"
                autosize
                class="textarea_box"
              ></el-input>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="subscribeTime">
          <template #label>
            <span
              >5、
              <span class="type_text">[单选]</span>
              预约时间（具体预约时间与咨询地点，以管院图书馆回复的邮件为准）</span
            >
          </template>
          <el-radio-group v-model="form.subscribeTime" class="group_box">
            <el-radio
              v-for="(item, index) in dateList"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="email">
          <template #label>
            <span> 6、<span class="type_text">[填写]</span> 联系邮箱</span>
          </template>
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <template #label>
            <span> 7、<span class="type_text">[填写]</span> 联系电话</span>
          </template>
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="code_box">
            <el-input v-model="form.code" style="width: 120px" />
            <div class="bg_code">
              <div class="code" @click="generateRandomNumber">
                {{ randomNumber }}
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div style="text-align: center">
            <el-button
              type="primary"
              style="width: 200px"
              @click="submitForm"
              :loading="loading"
              v-if="config.enable == '1' && pNumber > 0"
              >提交预约</el-button
            >
            <el-button
              type="primary"
              style="width: 200px"
              v-else-if="config.enable == '0'"
              disabled
              >本期预约服务暂停</el-button
            >
            <el-button
              type="primary"
              style="width: 200px"
              v-else-if="pNumber < 1"
              disabled
              >本期预约名额已满</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import FDBannerImg from "@c/FDBannerImg";
import dayjs from "dayjs";
import { post, get } from "@u/request";
const weekList = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];

export default {
  name: "Appointment",
  components: { FDBannerImg },
  data() {
    const validateItem = (rule, value, callback) => {
      if (value == "其他" && !this.otherItem) {
        callback(new Error("选择其他后必须填写内容"));
      }
      callback();
    };
    const validateConsultInfo = (rule, value, callback) => {
      const bool = value.every((item) => {
        const key = this.consult[item];
        return this.form[key];
      });
      if (!bool) {
        callback(new Error("勾选项必须填写内容"));
      }
      callback();
    };

    return {
      form: {
        consultInfo: [],
      },
      otherItem: "",
      dateList: [],
      rules: {
        name: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        rdrno: [
          { required: true, message: "请输入联系人学号", trigger: "blur" },
        ],
        item: [
          {
            required: true,
            message: "请选择联系人就读管院项目",
            trigger: "change",
          },
          { validator: validateItem, trigger: "change" },
        ],
        consultInfo: [
          { required: true, message: "请选择预约咨询内容", trigger: "change" },
          { validator: validateConsultInfo, trigger: "change" },
        ],
        subscribeTime: [
          { required: true, message: "请选择预约时间", trigger: "change" },
        ],
        email: [
          { required: true, message: "请输入联系人邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱格式",
            trigger: "blur",
          },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      randomNumber: "",
      loading: false,
      consult: {
        图书馆资源检索: "input1",
        学位论文参考文献引用咨询: "input2",
        学位论文格式规范问题咨询: "input3",
        其他: "input4",
      },

      config: {},
    };
  },
  computed: {
    pNumber() {
      return this.$store.getters.pNumber;
    },
  },
  methods: {
    getDate() {
      //   const week = dayjs().startOf("week").add(8, "day").format("YYYY-MM-DD");
      for (let index = 0; index < 7; index++) {
        const value = dayjs()
          .startOf("week")
          .add(8 + index, "day")
          .format("YYYY-MM-DD");
        const month = dayjs(value).month() + 1;
        const date = dayjs(value).date();
        const label = `${month}月${date}日（${weekList[index]}）10:00-16:00`;
        this.dateList.push({
          label,
          value,
        });
      }
    },
    resetForm() {
      this.form = {
        consultInfo: [],
      };
      this.otherItem = "";
    },
    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const consultInfo = this.form.consultInfo.map((item) => {
            const key = this.consult[item];
            return `${item}——${this.form[key]}`;
          });

          const params = {
            ...this.form,
            consultInfo: consultInfo.join("；"),
            item:
              this.form.item == "其他"
                ? `${this.form.item}——${this.otherItem}`
                : this.form.item, // 选择其他项时需要把文本框内容拼接进去
          };
          try {
            this.loading = true;
            const { data, msg } = await post("/lib/consult/add", params);
            this.$message.success(msg);
            this.resetForm();
            this.$refs.ruleForm.resetFields();
            this.generateRandomNumber();
            this.$store.dispatch("getCheck");

            this.$router.push("/");
          } catch (error) {
          } finally {
            this.loading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    generateRandomNumber() {
      this.randomNumber = "";
      for (var i = 0; i < 4; i++) {
        this.randomNumber += Math.floor(Math.random() * 10);
      }
    },
    async getConfig() {
      const { data } = await get("lib/consult/getConfig");
      const config = data[0];
      if (config) {
        this.config = config;
      }
    },
  },
  mounted() {
    this.getDate();
    this.getConfig();
    this.generateRandomNumber();
  },
};
</script>

<style scoped lang="scss">
.appointment_wrap {
  padding: 60px 0;
  width: 1400px;
  margin: 0 auto;
  .title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }
  .tips_box {
    margin-bottom: 30px;
    padding: 20px 16px;
    // background-color: #ecf8ff;
    // border-radius: 4px;
    // border-left: 5px solid #50bfff;
    font-size: 18px;
    color: #5e6d82;
    line-height: 1.5;
    pre {
      white-space: break-spaces;
    }
  }
  .type_text {
    color: #aaa;
  }
  .group_box {
    display: flex;
    flex-direction: column;
  }
  .textarea_box {
    vertical-align: middle;
  }
  .code_box {
    display: flex;
    .bg_code {
      background-color: #e5e5e5;
      border-radius: 5px;
      margin-left: 20px;
      user-select: none;
    }
    .code {
      text-align: center;
      font-size: 30px;
      font-style: italic;
      font-weight: bold;
      cursor: pointer;
      padding: 2px 20px 2px 14px;
      background: linear-gradient(
        to right,
        red,
        orange,
        yellow,
        green,
        cyan,
        blue,
        violet
      );
      -webkit-background-clip: text;
      color: transparent;
    }
  }
}
::v-deep {
  .el-form--label-top .el-form-item__label {
    padding: 0;
    color: #333;
    font-size: 16px;
  }
  .el-radio {
    padding: 6px 0;
    margin-bottom: 10px;
  }
}
</style>
